import { Table, Button, Space, Card, Skeleton, Tag, Image, message } from 'antd';
import { News} from '../typing/table_typing';
import { Component } from 'react';
import { cardmargin, grayheader } from '../../CSSReferences';
import { FormattedMessage } from 'react-intl';
import { injectIntl } from '../../../intl-compat';

export interface TableThingyMainProps{
  data:{
    newslist:News[],
  }
  view:
  {
    loaded: boolean,
    autorefresh: boolean,
  }
  onLoadRequested:()=>void;
  onValueChange:(what:string, uuid:string)=>void;
  onPublishNews:(newsfeed:News[])=>void;
}

interface TableThinyViewInnerState{filteredInfo:any, sortedInfo:any}

class TableThingyView extends Component<TableThingyMainProps& {intl:any}, TableThinyViewInnerState> 
{
    constructor(props:TableThingyMainProps& {intl:any}){
      super(props);
      this.state = {
        filteredInfo: null,
        sortedInfo: null,
      };
    }


    componentDidMount(){
       setTimeout(() => {
        //setInterval(() => {
         // console.log(Date.now());
        this.props.onLoadRequested()
      }, 120);
      
      // this.props.onButtonClicked();
    }
   
    handleChange = (pagination:any, filters:any, sorter:any) => {
        console.log('Various parameters', pagination, filters, sorter);
        this.setState({
          filteredInfo: filters,
          sortedInfo: sorter,
        });
      };
    
      clearFilters = () => {
        this.setState({
        filteredInfo: null,
      });
      };
    
      clearAll = () => {
        this.setState({
          filteredInfo: null,
          sortedInfo: null,
        });
      };
    
      setAgeSort = () => {
        this.setState({
          sortedInfo: {
            order: 'descend',
            columnKey: 'age',
          },
        });
      };
      

      toggleselect = (uuid:string) => {
          this.props.onValueChange("select", uuid)
      };

      toggledelete = (uuid:string) => {
        this.props.onValueChange("delete", uuid)
      };

      publishNews = () => {
        message.success("News will be published")
        this.props.onPublishNews(this.props.data.newslist)
      };

render(){
  let { sortedInfo  } = this.state;
    sortedInfo = sortedInfo || {};

    const columns = [

      {
        title: <FormattedMessage id="Title" defaultMessage="Title" />,
        dataIndex: 'title',
        key: 'title',
        sorter: (a:any, b:any) => a.title - b.title,
        sortOrder: sortedInfo.columnKey === 'title' && sortedInfo.order,
        ellipsis: false,
        render: (type:any, b:any) => (
           <div> <Image width={150} src={b.image} /> 
           <br />
           {b.title}
           <br/>
           {b.source}
          <br />
            {b.tag.split(';').map((item:string) => {
              return(<Tag>{item}</Tag>)
            })}
            <br />
           <a href={b.link} target="_blank" rel="noreferrer">{b.link}</a>
           </div>
          
          ),
      },
  
     
      {
        title: <FormattedMessage id="description" defaultMessage="description" />,
        dataIndex: 'description',
        key: 'description',
        sorter: (a:any, b:any) => a.description - b.description,
        sortOrder: sortedInfo.columnKey === 'description' && sortedInfo.order,
        ellipsis: false,
        render: (type:any, b:any) => (
          <div>
          {b.description}
          </div>
          ),
      },
      {
        title: <FormattedMessage id="published" defaultMessage="published" />,
        dataIndex: 'published',
        key: 'published',
        filters: [],
        filteredValue: null,
        onFilter: (value:any, record:any) => record.published.includes(value),
        sorter: (a:any, b:any) => a.published.length - b.published.length,
        sortOrder: sortedInfo.columnKey === 'published' && sortedInfo.order,
        ellipsis: true,
        render: (type:any, b:any) => (
          <>
          {b.published}
          <br/>          
          <Button type={b.selected===true?"primary":"default"}  onClick={() => this.toggleselect(b.uuid)}>
          {(b.selected===true)?
            <FormattedMessage id="publish" defaultMessage="publish" />
            :
            <FormattedMessage id="publish?" defaultMessage="publish?" />
          }
          </Button>
          <br/>          
          <Button type={b.todelete===true?"primary":"default"} danger onClick={() => this.toggledelete(b.uuid)}>
          {(b.todelete===true)?
            <FormattedMessage id="DELETE" defaultMessage="DELETE" />
            :
            <FormattedMessage id="delete?" defaultMessage="delete?" />
          }
          </Button>

          
          </>

        ),
      },
    ];

    if (this.props.view.loaded === false)
    {
      return (
        <div>
          <Card title={<FormattedMessage id="Newslist" defaultMessage="Active Newslist" />} style={cardmargin}   hoverable styles={{ header: grayheader }}>
          <Skeleton active />
          </Card>
          </div>
      )    
    }
    else
    {
  return (
    <div>
      <Card title={<FormattedMessage id="Newslist" defaultMessage="Newslist" /> } style={cardmargin}   hoverable styles={{ header: grayheader }}>
      <Button type="primary" onClick={() => this.publishNews()}><FormattedMessage id="Publish news" defaultMessage="Publish News" /></Button>

    <Space style={{ marginBottom: 16 }}>
      {/* <Button onClick={this.setAgeSort}>Sort age</Button>
      <Button onClick={this.clearFilters}>Clear filters</Button>
      <Button onClick={this.clearAll}>Clear filters and sorters</Button> */}
    </Space>
    <Table columns={columns} dataSource={this.props.data.newslist} onChange={this.handleChange} />
    </Card>
    </div>
  )}
}
}

export default injectIntl(TableThingyView);